import { ValidationFailure } from "./validation-failure";

export class ValidationError extends Error {
    readonly name: string = "ValidationError";

    readonly failures: Array<ValidationFailure>;

    constructor(message: string, ...failures: Array<ValidationFailure>) {
        super(message);
        Object.setPrototypeOf(this, new.target.prototype);

        this.failures = [...(failures ?? [])];
    }
}
